<main class="recovery-page">
  <section class="recovery-card">
    <div class="recovery-header">
      <div class="recovery-icon">
        <i class="fas fa-shield-alt"></i>
      </div>

      <h2>Recuperar contraseña</h2>
      <p>
        Sigue los pasos de verificación para restablecer el acceso a tu cuenta.
      </p>
    </div>

    <div class="steps" aria-label="Progreso de recuperación">
      <span [class.active]="paso === 1" [class.done]="paso > 1">1</span>
      <div [class.active]="paso >= 2"></div>
      <span [class.active]="paso === 2" [class.done]="paso > 2">2</span>
      <div [class.active]="paso >= 3"></div>
      <span [class.active]="paso === 3">3</span>
    </div>

    <!-- PASO 1 -->
    <div *ngIf="paso === 1" class="step-content">
      <p class="descripcion">
        Ingresa tu correo electrónico y te enviaremos un código de verificación.
      </p>

      <div class="form-group">
        <label for="correo">Correo electrónico</label>

        <div class="input-wrapper">
          <i class="far fa-envelope"></i>

          <input
            id="correo"
            [(ngModel)]="correo"
            name="correo"
            type="email"
            placeholder="ejemplo@correo.com"
            required
          />
        </div>
      </div>

      <button type="button" class="primary-btn" (click)="enviarCodigo()">
        <i class="fas fa-paper-plane"></i>
        Enviar código
      </button>

      <a routerLink="/login" class="volver">
        <i class="fas fa-arrow-left"></i>
        Volver al login
      </a>
    </div>

    <!-- PASO 2 -->
    <div *ngIf="paso === 2" class="step-content">
      <p class="descripcion">
        Ingresa el código que recibiste y define tu nueva contraseña.
      </p>

      <div class="notice-box">
        <i class="fas fa-circle-info"></i>
        <div>
          <span>El correo puede tardar unos minutos en llegar.</span>
          <strong>Revisa también Spam o No deseados.</strong>
        </div>
      </div>

      <div class="form-group">
        <label for="codigo">Código de verificación</label>

        <div class="input-wrapper">
          <i class="fas fa-key"></i>

          <input
            id="codigo"
            [(ngModel)]="codigo"
            name="codigo"
            type="text"
            placeholder="Código de 6 dígitos"
            required
          />
        </div>
      </div>

      <div class="form-group">
        <label for="nuevaContrasena">Nueva contraseña</label>

        <div class="input-wrapper">
          <i class="fas fa-lock"></i>

          <input
            id="nuevaContrasena"
            [(ngModel)]="nuevaContrasena"
            name="nuevaContrasena"
            [type]="mostrarPassword ? 'text' : 'password'"
            placeholder="Mínimo 8 caracteres"
            required
          />

          <button
            type="button"
            class="password-toggle"
            (click)="mostrarPassword = !mostrarPassword"
            [attr.aria-label]="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          >
            <i
              class="fas"
              [ngClass]="mostrarPassword ? 'fa-eye-slash' : 'fa-eye'"
            ></i>
          </button>
        </div>
      </div>

      <button type="button" class="primary-btn" (click)="cambiarContrasena()">
        <i class="fas fa-check-circle"></i>
        Cambiar contraseña
      </button>

      <a routerLink="/login" class="volver">
        <i class="fas fa-arrow-left"></i>
        Volver al login
      </a>
    </div>

    <!-- PASO 3 -->
    <div *ngIf="paso === 3" class="step-content exito">
      <div class="success-icon">
        <i class="fas fa-check"></i>
      </div>

      <h3>Contraseña actualizada</h3>

      <p>{{ mensaje }}</p>

      <a routerLink="/login" class="primary-link">
        Ir al login
      </a>
    </div>

    <app-alert
      *ngIf="mensaje && paso !== 3"
      tipo="exito"
      [texto]="mensaje"
    ></app-alert>

    <app-alert
      *ngIf="error"
      tipo="error"
      [texto]="error"
    ></app-alert>
  </section>
</main>